import React, { useState } from 'react';
import { Box, Button, Typography, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useAuth } from '@/lib/firebase/auth';
import { useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
  const { user, sendVerificationEmail, logout } = useAuth();
  const navigate = useNavigate();
  
  const [emailSent, setEmailSent] = useState(false); // Track if email has been sent
  const [showSuccess, setShowSuccess] = useState(false); // Control success message visibility
  const [showConfirmDialog, setShowConfirmDialog] = useState(false); // Control dialog visibility
  
  const handleOpenConfirmDialog = () => {
    setShowConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setShowConfirmDialog(false);
  };

  const handleResendVerification = async () => {
    try {
      await sendVerificationEmail();
      setEmailSent(true); // Disable button after sending
      setShowSuccess(true); // Show success message
      handleCloseConfirmDialog(); // Close the dialog after sending
    } catch (error) {
      console.error("Error resending verification email:", error);
    }
  };

  const handleCloseSuccess = () => {
    setShowSuccess(false);
  };

  return (
    <Box p={3} borderRadius={4} maxWidth={600} boxShadow={3} mx="auto" mt={8}>
      <Typography variant="h4" align="center" mb={3}>
        Complete Email Verification
      </Typography>
      <Typography variant="body1" align="center" mb={3}>
        To complete your account setup, please verify your email address by clicking the link sent to <b>{user.email}</b>.
      </Typography>
      <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
        <Button
          variant="outlined"
          onClick={handleOpenConfirmDialog}
          disabled={emailSent} // Disable button after one send
        >
          Resend Verification Email
        </Button>
      </Box>
      
      {/* Success Message Snackbar */}
      <Snackbar open={showSuccess} autoHideDuration={6000} onClose={handleCloseSuccess}>
        <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
          Verification email has been resent. Please check your inbox.
        </Alert>
      </Snackbar>

      {/* Confirmation Dialog */}
      <Dialog open={showConfirmDialog} onClose={handleCloseConfirmDialog}>
        <DialogTitle>Resend Verification Email</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to resend the verification email? Please check your inbox and spam folder for the previous email before proceeding.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleResendVerification} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default VerifyEmail;
